let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    jQuery('.header .hamburger').trigger('click')

})

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    if (jQuery(this).hasClass('is-active')) {
        jQuery('.drawer').attr('tabindex', '-1')
    } else {
        jQuery('.drawer').attr('tabindex', '1').focus()
        // jQuery('.drawer__search button').focus()
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')

})

jQuery(window).on('scroll', function () {
    if ( jQuery(window).scrollTop() > 200 ) {
        jQuery('.header__strip').addClass('hidden');
    } else {
        jQuery('.header__strip').removeClass('hidden');
    }

    let height = jQuery('.header').height()

    if ( jQuery('#wpadminbar').length > 0 )
        height = height - jQuery('#wpadminbar').outerHeight()

    jQuery('body').css( {'padding-top' : height + 'px' } )
})

jQuery('.drawer__nav .toggle').on('click', function (e) {
    e.preventDefault()

    let thisEl = jQuery(this),
        parentEl = thisEl.parent()

    if (parentEl.hasClass('open')) {
        parentEl.toggleClass('open').next().slideToggle()
    } else {
        parentEl.toggleClass('open', false).next().slideToggle()
        parentEl.addClass( 'open' )
    }
})
